import React, { useState, useContext } from "react";
import AuthContext from "../../context/authContext";

const Address = () => {
  const { addAddress, error, loading } = useContext(AuthContext);
  
  const [rua, setrua] = useState("");
  const [cidade, setCidade] = useState("");
  const [provincia, setprovincia] = useState("");
  const [pais, setpais] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const endereco = { rua, cidade, provincia, pais };

    try {
      await addAddress(endereco);
      alert("Endereço adicionado com sucesso!");
    } catch (err) {
      console.error("Erro ao adicionar endereço:", error);
    }
  };

  return (
    <div>
      <h2>Adicionar Endereço</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>rua:</label>
          <input 
            type="text" 
            value={rua} 
            onChange={(e) => setrua(e.target.value)} 
            required 
          />
        </div>
        <div>
          <label>Cidade:</label>
          <input 
            type="text" 
            value={cidade} 
            onChange={(e) => setCidade(e.target.value)} 
            required 
          />
        </div>
        <div>
          <label>provincia:</label>
          <input 
            type="text" 
            value={provincia} 
            onChange={(e) => setprovincia(e.target.value)} 
            required 
          />
        </div>
        <div>
          <label>pais:</label>
          <input 
            type="text" 
            value={pais} 
            onChange={(e) => setpais(e.target.value)} 
            required 
          />
        </div>
        {error && <div style={{ color: "red" }}>{error}</div>}
        <div>
          <button type="submit" disabled={loading}>
            {loading ? "Adicionando..." : "Adicionar Endereço"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Address;
